<template>
  <div>
    <div class="kqf-card mg10 search-box mt20">
      <el-form
        :inline="true"
        :model="search"
        size="mini"
        class="demo-form-inline"
      >
        <el-col :span="24">
          <el-form-item label="关键字：">
            <el-input v-model="search.keyword" placeholder="关键字"></el-input>
          </el-form-item>
          <el-form-item label="IMEI序列号：" class="ml20">
            <el-input v-model="search.imei" placeholder="IMEI序列号"></el-input>
          </el-form-item>
          <el-form-item label="查询名称：" class="ml20">
            <el-input
              v-model="search.menu_name"
              placeholder="查询名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="line-dashed mb10"></div>
        </el-col>
        <el-form-item label="状态：">
          <el-radio-group v-model="search.status" @input="getList(1)">
            <el-radio :label="-1">全部</el-radio>
            <el-radio :label="0">失败</el-radio>
            <el-radio :label="1">成功</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="创建时间：" class="ml20">
          <div class="block">
            <el-date-picker
              v-model="search.create_time"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item class="ml20">
          <el-button type="primary" @click="getList(1)">查询</el-button>
          <el-button @click="refresh">重置</el-button>
		  <el-button @click="exportClick" type="success" plain>导出</el-button>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            总金额：<span class="num">{{ datas.all_money }}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="kqf-card mg10 pd10 mt20"
      v-loading="loading"
      style="min-width: 1100px"
    >
      <el-table border :data="datas.list" height="calc(100vh - 330px)">
        <el-table-column
          label="ID"
          width="80"
          prop="order_id"
        ></el-table-column>
        <el-table-column label="用户信息" width="200">
          <template slot-scope="scope">
            <div class="flex">
              <el-avatar :size="40" :src="scope.row.face"></el-avatar>
              <div style="margin-left: 10px">
                <p class="text-over">{{ scope.row.nickname }}</p>
                <el-link
                  v-clipboard:success="copySuccess"
                  v-clipboard:copy="scope.row.mobile"
                  type="primary"
                  :underline="false"
                  >{{ scope.row.mobile }}
                </el-link>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="IMEI序列号"
          width="200"
          prop="imei"
        ></el-table-column>
        <el-table-column label="查询名称" prop="menu_name"></el-table-column>
        <el-table-column
          label="推广ID"
          width="100"
          prop="agent_uid"
        ></el-table-column>
        <el-table-column label="查询类型" prop="menu_id"></el-table-column>
        <el-table-column
          label="成本价"
          prop="cost_price"
          align="center"
        ></el-table-column>
        <el-table-column
          label="销售价格"
          prop="price"
          align="center"
        ></el-table-column>
        <el-table-column
          label="支付金额"
          prop="pay_price"
          align="center"
        ></el-table-column>
        <el-table-column
          label="分类ID"
          prop="category_id"
          align="center"
        ></el-table-column>

        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.status == 0">失败</el-tag>
            <el-tag type="success" v-if="scope.row.status == 1">成功</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="查询时间"
          width="150"
          prop="date"
          align="center"
        ></el-table-column>
        <el-table-column
          label="创建时间"
          width="180"
          prop="create_time"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="detailInfo(scope.row)"
              icon="el-icon-edit"
              type="primary"
              style="margin-right: 10px"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="flex center mt10">
        <div>
          <el-pagination
            @current-change="getList"
            background
            :page-size="datas.limit"
            layout="total, prev, pager, next"
            :total="datas.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderManage } from "../../request/api/orderManage/orderManage";
import XLSX from 'xlsx'
export default {
  data() {
    return {
      datas: [],
      search: this.getSearch(),
      //编辑信息
      editloading: false,
      editdialog: false,
      editdata: {
        keyword: "",
        remarks: "",
        entry_type: -1,
        type: -1,
        entry_id: "",
        created_at: ""
      },
      loading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getSearch() {
      return {
        keyword: "",
        imei: "",
        status: -1,
        create_time: "",
        menu_name: "",
        page: 1
      };
    },
    getList(page) {
      this.search.page = page;
      this.loading = true;
      getOrderManage({
        keyword: this.search.keyword,
        imei: this.search.imei,
        status: this.search.status,
        create_time: this.search.create_time,
        menu_name: this.search.menu_name,
        page: page
      })
        .then(res => {
          this.datas = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    refresh() {
      this.search = this.getSearch();
      this.getList(1);
    },
    // 复制
    copySuccess() {
      this.$message.success("复制成功");
    },
    detailInfo(row) {
      this.$router.push({
        query: { order_id: row.order_id },
        path: "/orderManage/detail"
      });
    },
	//导出
	exportClick(){
	    this.loading = true;
	    getOrderManage({
	      keyword: this.search.keyword,
	      imei: this.search.imei,
	      status: this.search.status,
	      create_time: this.search.create_time,
	      menu_name: this.search.menu_name,
	      page: 1,
		  is_excel:1
	    }).then(res => {
	        this.loading = false;
	        let excelDataAll = [
	            ['ID','用户名称','手机号','IMEI序列号','查询名称','推广ID','查询类型','成本价','销售价格','支付金额','分类ID','状态','查询时间'],
	        ]
	        let excelData = []
	        res.list.forEach((item)=>{
	            excelData.push(item.order_id)
	            excelData.push(item.nickname)
	            excelData.push(item.mobile)
	            excelData.push(item.imei)
	            excelData.push(item.menu_name)
	            excelData.push(item.agent_uid)
	            excelData.push(item.menu_id)
	            excelData.push(item.cost_price)
	            excelData.push(item.price)
	            excelData.push(item.pay_price)
	            excelData.push(item.category_id)
	            excelData.push(item.status == 1 ? '成功' : '失败')
	            excelData.push(item.create_time)
	            excelDataAll.push(excelData)
	            excelData = []
	        })
	        console.log('aaa=>',excelDataAll)
	        const ws = XLSX.utils.aoa_to_sheet(excelDataAll)
	        const wb = XLSX.utils.book_new()
	        XLSX.utils.book_append_sheet(wb,ws,'Sheet1')
	        XLSX.writeFile(wb,'查询订单.xlsx')
	    }).catch(() => {
	        this.loading = false;
	    });
	}
  }
};
</script>
<style scoped>
.allMoney {
  margin-left: 20px;
}
.allMoney .num {
  font-size: 15px;
  color: #ff5646;
}
</style>
